import pick from 'lodash/pick';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input, { LEFT, CENTER } from '../Input/InputView';
import { extractFirstLongestNumberFromString } from '../../../js/app/react/stringNumericUtils';

import { isNumeric } from '../../../js/app/react/validators';

export default class InputAge extends Component {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  onChange(eventArg) {
    const event = pick(eventArg, ['target']);
    const amount = eventArg.target.value;
    if ((amount || '').length === 0) {
      event.target.value = '';
    } else if (isNumeric(amount)) {
      event.target.value = parseInt(amount, 10);
    } else {
      event.target.value = extractFirstLongestNumberFromString(amount);
    }
    this.props.onChange(event);
    eventArg.preventDefault();
    eventArg.stopPropagation();
  }

  render() {
    const {
      value,
      placeholder,
      className,
      maxLength,
      placeholderClassName,
      isLeftAligned,
      isUnder,
      id,
    } = this.props;

    return (
      <div className={`input-age ${className}`}>
        <Input
          alignment={isLeftAligned ? LEFT : CENTER}
          placeholder={placeholder}
          placeholderClassName={placeholderClassName}
          value={value}
          type="tel"
          isUnder={isUnder}
          maxLength={maxLength}
          id={id}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
InputAge.defaultProps = {
  className: '',
  value: '',
  placeholderClassName: '',
  isLeftAligned: false,
  isUnder: undefined,
  id: undefined,
};

InputAge.propTypes = {
  placeholderClassName: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  isLeftAligned: PropTypes.bool,
  isUnder: PropTypes.bool,
  id: PropTypes.string,
};
